import { Color } from "../../defines/colors"
import { ItemType } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position } from "../../defines/types"
import { getEquipment, isGizmo, isWardrobe } from "../../utils/equipment"
import { Item } from "./item"

export class Equipment extends Item {
  constructor(type: ItemType, levelRequired: number, position: Position) {
    const render = {
      symbol: getSymbol(type),
      light: getLightColor(type),
      dark: getDarkColor(type),
    }
    super(type, levelRequired, position, render, getName(type))
  }
}

function getSymbol(type: ItemType): string[] {
  let symbol = Symbol.ARMAMENT

  if (isWardrobe(type)) {
    symbol = Symbol.WEARABLE
  } else if (isGizmo(type)) {
    symbol = Symbol.GIZMO
  }

  return [symbol]
}

function getLightColor(type: ItemType): string {
  let color = Color.ARMAMENT

  if (isWardrobe(type)) {
    color = Color.WEARABLE
  } else if (isGizmo(type)) {
    color = Color.GIZMO
  }

  return color
}

function getDarkColor(type: ItemType): string {
  let color = Color.ARMAMENT_DARK

  if (isWardrobe(type)) {
    color = Color.WEARABLE_DARK
  } else if (isGizmo(type)) {
    color = Color.GIZMO_DARK
  }

  return color
}

function getName(type: ItemType): string {
  const e = getEquipment(type)
  if (e !== undefined) {
    return e.name
  } else {
    return ""
  }
}
